import StickyHeader from "@/components/landing/StickyHeader";
import HeroSection from "@/components/landing/HeroSection";
import TrustBand from "@/components/landing/TrustBand";
import WhatIsSection from "@/components/landing/WhatIsSection";
import ForWhoSection from "@/components/landing/ForWhoSection";
import StepsSection from "@/components/landing/StepsSection";
import WhyUsSection from "@/components/landing/WhyUsSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import CtaSection from "@/components/landing/CtaSection";
import FaqSection from "@/components/landing/FaqSection";
import FooterSection from "@/components/landing/FooterSection";

const BilanCompetences = () => (
  <>
    <StickyHeader />
    <HeroSection />
    <TrustBand />
    <WhatIsSection />
    <ForWhoSection />
    <StepsSection />
    <WhyUsSection />
    <TestimonialsSection />
    <CtaSection />
    <FaqSection />
    <FooterSection />
  </>
);

export default BilanCompetences;
